import { action } from 'mobx';
import { BasePreviewViewStore} from 'core/stores';
import {applicationContext} from 'core/utils';
import {CorporateService} from 'application/corporate/services';

@applicationContext
class CorporatePreviewStore extends BasePreviewViewStore {
    constructor(rootStore) {
        const id = rootStore.routerStore.routerState.params.id;
        const isNiko = !!(rootStore.routerStore.routerState.queryParams &&
            (rootStore.routerStore.routerState.queryParams.isNiko === true ||
             rootStore.routerStore.routerState.queryParams.isNiko === 'true'));
        super(rootStore, {
            name: 'corporate',
            id: id,
            authorization: 'portalSection.update',
            routes: {
                edit: () => {
                        this.rootStore.routerStore.setTransitionData({
                            navigationTitle: this.item.name
                        });
                        this.rootStore.routerStore.goTo(
                         'master.app.main.corporate.edit',
                         { id: this.id },
                         isNiko ? { isNiko: true } : undefined);
                }
            },
            actions: () => {
                const service = new CorporateService(rootStore.application.baasic.apiClient);                                
                return {
                    get: async (id) => {
                        const response = await service.get(id, { embed: 'CorporateContacts,Facilities,ReportingIntervalType' });
                        
                        return {
                            ...response.data,
                            reportingIntervalType: response.data.reportingIntervalType ? response.data.reportingIntervalType.name : ''
                        };
                    }
                }
            }
        });
    }
    
    @action.bound
    async getResource(id) {
        await super.getResource(id);
    }
}

export default CorporatePreviewStore;
